/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SBE SMS API
 * SMS API. AccessTokenGuard 보호 라우트는 Authorization: Bearer <jwt> 가 필요.
 * OpenAPI spec version: 1.0
 */

/**
 * UI 아이콘·색 결정용 표시 성격
 */
export type NotificationListItemDtoLevel = typeof NotificationListItemDtoLevel[keyof typeof NotificationListItemDtoLevel];


export const NotificationListItemDtoLevel = {
  Info: 'Info',
  Success: 'Success',
  Warning: 'Warning',
  Error: 'Error',
} as const;
